export default "__VITE_ASSET__CAwxWS61__"